export enum HMSVideoCodec {
  H264 = 'H264',
  VP8 = 'VP8',
  VP9 = 'VP9',
  H265 = 'H265',
}
